export const TIER_LABEL = {
  1: 'Basic',
  2: 'Standard',
  3: 'Advanced',
  4: 'Elite',
};

const TIER_NAME_MAP = {
  basic: 'Basic',
  standard: 'Standard',
  advanced: 'Advanced',
  elite: 'Elite',
};

export const normalizeTier = (raw) => {
  if (raw == null) return null;
  if (TIER_LABEL[raw]) return TIER_LABEL[raw];

  const value = String(raw).trim().toLowerCase();
  if (!value) return null;
  return TIER_NAME_MAP[value] ?? null;
};

export const TIER_BASE_COLORS = {
  Basic: '#885E4B',
  Standard: '#515151',
  Advanced: '#44371E',
  Elite: '#04149D',
};

export const TIER_GRADIENTS = {
  Basic: 'linear-gradient(90deg, #885E4B 0%, #CCA18E 48%, #865C48 100%)',
  Standard: 'linear-gradient(90deg, #515151 0%, #BFBFBF 48%, #A2A2A2 100%)',
  Advanced: 'linear-gradient(90deg, #44371E 0%, #D0A60E 48%, #533E13 100%)',
  Elite: 'linear-gradient(90deg, #04149D 0%, #1E95C8 48%, #04149D 100%)',
};

export const getTierGradient = (tier) => (tier ? TIER_GRADIENTS[tier] ?? null : null);

export const resolveTierFromUser = (user) => {
  if (!user) return null;
  const candidates = [
    user.tier,
    user.tier_id,
    user.tierId,
    user.tier_code,
    user.tierCode,
  ];

  for (const candidate of candidates) {
    const normalized = normalizeTier(candidate);
    if (normalized) return normalized;
  }

  return null;
};

export const readTierFromStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    const value = localStorage.getItem('user_tier');
    return normalizeTier(value);
  } catch {
    return null;
  }
};
